import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../../api";
import Model from "../../../models/templates";
import validateForm from "../../../lib/helpers/validateForm";

// UI
import {
  HeaderPage,
  Table,
  Button,
  Modal,
  Alerts,
  Input,
  P
} from "../../../ui";

class TemplatesListPage extends Component {
  state = {
    titleHeader: "Шаблоны документов",
    loading: true,
    templates: [],
    form: {
      template_name: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.template_name
      }
    },
    modalActionView: "create",
    selectedItemId: "",
    saveDisabled: false,
    modalShow: false
  };

  async componentDidMount() {
    await this.loadingData();
  }

  loadingData = async () => {
    const result = await API.settings.template.getList();

    this.setState({
      loading: false,
      templates: result || []
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => i + 1
      },
      {
        title: "Название",
        render: ({ item }) => {
          return (
            <Link to={`/settings/templates/${item._id}`}>
              {item.template_name}
            </Link>
          );
        }
      },
      {
        title: "-",
        render: ({ item }) => {
          return (
            <Button
              type="button"
              theme="default"
              size="s"
              name={`${item._id}:edit`}
              onClick={e => this.handleModalOpen(e, "edit", item._id)}
            >
              Изменить
            </Button>
          );
        }
      },
      {
        title: "-",
        render: ({ item }) => {
          return (
            <Button
              type="button"
              theme="error"
              size="s"
              name={`${item._id}:delete`}
              onClick={e => this.handleModalOpen(e, "delete", item._id)}
            >
              Удалить
            </Button>
          );
        }
      }
    ];
  };

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleFormSubmitDelete = async e => {
    if (e) {
      e.preventDefault();
    }

    // Отключаем кнопку
    this.setState({
      saveDisabled: true,
      loading: true
    });
    // Создание нового
    await API.settings.template.deleteOne(this.state.selectedItemId);

    Alerts.success(`Удалён шаблон документа`);

    // Включаем кнопку, данные сохранились
    this.setState({
      saveDisabled: false,
      loading: false
    });

    this.handleModalShowCancel();

    await this.loadingData();
  };

  handleFormSubmit = async e => {
    if (this.state.modalActionView === "delete") {
      this.handleFormSubmitDelete(e);
      return;
    }

    if (e) {
      e.preventDefault();
    }

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      // Отключаем кнопку
      this.setState({ saveDisabled: true, loading: true });

      const { form } = this.state;
      const optionsRequest = {};

      // все поля
      for (let nameItem in form) {
        optionsRequest[nameItem] = form[nameItem].value;
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length === Object.keys(form).length) {
        if (this.state.selectedItemId !== "") {
          // Изменение одного
          await API.settings.template.editOne(this.state.selectedItemId, {
            ...optionsRequest
          });
        } else {
          // Создание нового
          await API.settings.template.createOne({
            ...optionsRequest
          });
        }

        Alerts.success(
          `${
            this.state.selectedItemId !== "" ? "Изменён" : "Создан новый"
          } шаблон документа`
        );

        // Включаем кнопку, данные сохранились
        this.setState({
          saveDisabled: false,
          loading: false
        });

        this.handleModalShowCancel();

        await this.loadingData();
      } else {
        Alerts.alert("Заполните нужные поля");

        // Включаем кнопку, данные не сохранились
        this.setState({
          saveDisabled: false,
          loading: false
        });
      }
    }
  };

  /**
   * Открытие мобального окна
   */
  handleModalShow = isShow => {
    this.setState({
      modalShow: isShow
    });
  };

  handleModalOpen = (e, modalActionView, itemId) => {
    if (e) {
      e.preventDefault();
    }

    let { form, templates } = this.state;

    if (modalActionView !== "create") {
      for (let t of templates) {
        if (t._id === itemId) {
          form.template_name.value = t.template_name;

          break;
        }
      }
    }

    this.setState({
      form,
      modalActionView,
      selectedItemId: itemId,
      modalShow: true
    });
  };

  /**
   * Отмена мобального окна
   */
  handleModalShowCancel = () => {
    if (this.state.loading) {
      return;
    }

    let { form } = this.state;

    for (let k in form) {
      if (k.isBoolean) {
        form[k].value = false;
      } else {
        form[k].value = "";
      }

      form[k].isEdited = false;
      form[k].isError = false;
      form[k].errors = [];
    }

    this.setState({
      form,
      modalActionView: "create",
      selectedItemId: "",
      modalShow: false
    });
  };

  render() {
    const { templates } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          count={templates.length || 0}
        >
          <Button
            type="submit"
            theme="success"
            onClick={() => this.handleModalShow(true)}
          >
            Создать
          </Button>
        </HeaderPage>

        <Modal
          // width="sm"
          title={
            this.state.modalActionView === "delete"
              ? "Удалить шаблон"
              : "Создать шаблон"
          }
          show={this.state.modalShow}
          yesTitle={
            this.state.modalActionView === "delete" ? "Удалить" : "Сохранить"
          }
          yesHandlerOnClick={e =>
            this.state.saveDisabled ? function() {} : this.handleFormSubmit(e)
          }
          yesDisabled={this.state.saveDisabled}
          noHandlerOnClick={() =>
            this.state.saveDisabled
              ? function() {}
              : this.handleModalShowCancel()
          }
          noCloseOnClickOutside={this.state.saveDisabled}
        >
          {this.state.modalActionView === "delete" ? (
            <P>Вы действительно хотите удалить шаблон документа?</P>
          ) : (
            <Input
              label="Название:"
              name="template_name"
              value={this.state.form.template_name.value}
              handleChange={this.handleInput}
              errors={this.state.form.template_name.errors}
              disabled={this.state.saveDisabled}
            />
          )}
        </Modal>

        <Table
          columns={this.getTableColumns()}
          data={templates || []}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(TemplatesListPage));
